import { g } from 'xojs/lib/runtime/getGlobal';

export function isMobile() {
  return g.innerWidth && g.innerWidth < 768;
}

export function isRealMobile() {
  return g.innerWidth && g.innerWidth < 520;
}